export const getApiErrorMessage = (error, fallback) => {
  const payload = error?.response?.data ?? error
  const validationItems = payload?.validationMessages || payload?.violations || payload?.errors
  const validationMessages = Array.isArray(validationItems)
    ? validationItems
      .map(item => (typeof item === 'string' ? item : item?.message || item?.defaultMessage))
      .filter(Boolean)
    : []

  if (validationMessages.length > 0) return validationMessages.join(' ')
  if (typeof payload === 'string' && payload.trim()) return payload
  if (typeof payload?.message === 'string' && payload.message.trim()) return payload.message
  if (typeof payload?.error === 'string' && payload.error.trim()) return payload.error
  if (typeof payload?.detail === 'string' && payload.detail.trim()) return payload.detail

  return fallback
}
